import { render } from "./FrmMultipointPalletizing.vue?vue&type=template&id=3bfa722c&scoped=true"
import script from "./FrmMultipointPalletizing.vue?vue&type=script&lang=js"
export * from "./FrmMultipointPalletizing.vue?vue&type=script&lang=js"

import "./FrmMultipointPalletizing.vue?vue&type=style&index=0&id=3bfa722c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bfa722c"]])

export default __exports__